"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

var _Icon = _interopRequireWildcard(require("../general/Icon"));

var _underscore = _interopRequireDefault(require("underscore"));

var _KeyboardUtils = require("../../util/KeyboardUtils");

var _StateContainer = require("../utils/StateContainer");

var _DeprecationUtils = require("../../util/DeprecationUtils");

/**
* @typedef RockerButton~labelValues
* @property {string} label
*     Selected label from labels array prop.
* @property {number} index
*     Index of selected label from labels array prop.
*/

/**
* @callback RockerButton~onValueChange
* @param {RockerButton~labelValues} labelValues
*     Label and label index.
*/

/**
* @class RockerButton
* @desc Rocker buttons implementation, supports 2 to 4 buttons (current CSS restriction).
*
* @param {string} [className]
*     CSS classes to be set on the top-level HTML container.
* @param {string} [data-id="rocker-button"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {boolean} [disabled=false]
*     Indicates whether component is disabled.
*
* @param {array} labels
*     Array of label strings to use as button titles.
* @param {boolean} noMargin
*     Removes the margin below the RockerButton.
*
* @param {RockerButton~onValueChange} [onValueChange]
*     Callback to be triggered when selection changes.
*
* @param {number} [selectedIndex=0]
*     The index of the selected label.
*     When not provided, the component will manage this value.
* @param {string} [selected=0]
*     The id or index of the selected label.
*     When not provided, the component will manage this value.
* @param {RockerButton.rockerTypes} [type]
*     Set to CHART for special style.
*
* @example
*      <RockerButton onValueChange={this._changeSubview}
*                    labels={["Profile", "Groups", "Services"]} />
*
*      , where this._changeSubview can be defined as:
*
*      _changeSubview: function (selectedView) {
*          console.log("++ _changeSubview: ",selectedView);
*      }
*/

/**
 * @enum {string}
 * @alias RockerButton.rockerTypes
 */
var rockerTypes = {
  /** default */
  DEFAULT: "default",

  /** chart */
  CHART: "chart",

  /** chart-small */
  CHART_SMALL: "chart-small",

  /** icon */
  ICON: "icon"
};

var getButtonPosition = function getButtonPosition(labels, selected) {
  if ((0, _typeof2.default)(labels[0]) === "object") {
    if (selected) {
      return (0, _findIndex.default)(labels).call(labels, function (_ref) {
        var id = _ref.id;
        return id === selected;
      });
    }

    return 0;
  } else {
    return selected;
  }
};

function RockerButtonBase(_ref2) {
  var autoFocus = _ref2.autoFocus,
      className = _ref2.className,
      dataId = _ref2["data-id"],
      disabled = _ref2.disabled,
      labelHints = _ref2.labelHints,
      labels = _ref2.labels,
      noMargin = _ref2.noMargin,
      onValueChange = _ref2.onValueChange,
      selectedIndex = _ref2.selectedIndex,
      selected = _ref2.selected,
      type = _ref2.type;
  var selectedValue = selectedIndex === undefined ? selected : selectedIndex;
  var position = getButtonPosition(labels, selectedValue);
  var classes = (0, _classnames2.default)("rocker-button", className, (0, _defineProperty2.default)({
    disabled: disabled,
    "rocker-button--chart-rocker": type === rockerTypes.CHART || type === rockerTypes.CHART_SMALL,
    "rocker-button--chart-rocker-small": type === rockerTypes.CHART_SMALL,
    "rocker-button--icon-rocker": type === rockerTypes.ICON,
    "rocker-button--no-margin": noMargin
  }, "sel-".concat(position), selectedValue !== null && selectedValue !== undefined));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rocker-button__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: classes
  }, (0, _map.default)(labels).call(labels, function (data, index) {
    var id = data.id,
        _data$label = data.label,
        label = _data$label === void 0 ? id || data : _data$label,
        icon = data.icon,
        props = (0, _objectWithoutProperties2.default)(data, ["id", "label", "icon"]);
    return /*#__PURE__*/_react.default.createElement(RockerButtonLabel, (0, _extends2.default)({
      autoFocus: index === position && autoFocus === true,
      helpText: labelHints ? labelHints[index] : undefined,
      key: id || index,
      id: id,
      index: index,
      text: type !== rockerTypes.ICON ? label : /*#__PURE__*/_react.default.createElement(_Icon.default, {
        iconName: icon,
        iconSize: _Icon.iconSizes.SM
      }),
      onClick: function onClick(payload, e) {
        if (disabled) {
          return;
        }

        onValueChange(payload, e);
      }
    }, props));
  })));
}

RockerButtonBase.propTypes = {
  autoFocus: _propTypes.default.bool,
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  labelHints: _propTypes.default.arrayOf(_propTypes.default.string),
  labels: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    label: _propTypes.default.node,
    icon: _propTypes.default.string,
    id: _propTypes.default.string
  })])),
  noMargin: _propTypes.default.bool,
  onValueChange: _propTypes.default.func,
  selectedIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  selected: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  type: _propTypes.default.oneOf((0, _values.default)(rockerTypes))
};
RockerButtonBase.defaultProps = {
  autoFocus: false,
  className: "",
  "data-id": "rocker-button",
  disabled: false,
  noMargin: false,
  onValueChange: _underscore.default.noop,
  selected: 0
};

function RockerButtonLabel(_ref3) {
  var autoFocus = _ref3.autoFocus,
      id = _ref3.id,
      helpText = _ref3.helpText,
      index = _ref3.index,
      onClick = _ref3.onClick,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? "" : _ref3$text;

  var _handleClick = function _handleClick(event) {
    onClick({
      label: text,
      id: id,
      index: index
    }, event);
  };

  var sanitizedDataId = function () {
    if (id !== undefined) {
      return id;
    } else if (typeof text === "string") {
      return text.toLowerCase().replace(/[^0-9a-z]/gi, "");
    } else {
      return index;
    }
  }();

  return helpText ? /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
    "data-id": "helphint-button_".concat(sanitizedDataId),
    placement: "top",
    delayShow: 500,
    hintText: helpText
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-id": "rocker-label_".concat(sanitizedDataId),
    className: "rocker-button__button",
    onClick: _handleClick,
    autoFocus: autoFocus,
    type: "button"
  }, text)) : /*#__PURE__*/_react.default.createElement("button", {
    "data-id": "rocker-label_".concat(sanitizedDataId),
    className: "rocker-button__button",
    onClick: _handleClick,
    autoFocus: autoFocus,
    type: "button"
  }, text);
}

RockerButtonLabel.propTypes = {
  "data-id": _propTypes.default.string,
  onClick: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  text: _propTypes.default.node,
  index: _propTypes.default.number
};
var RockerButton = (0, _KeyboardUtils.withFocusOutline)((0, _StateContainer.inStateContainer)([{
  name: "selected",
  initial: 0,
  callbacks: [{
    name: "onValueChange",
    transform: function transform(_ref4) {
      var index = _ref4.index,
          _ref4$id = _ref4.id,
          id = _ref4$id === void 0 ? index : _ref4$id;
      return id;
    }
  }]
}])(RockerButtonBase));
RockerButton.displayName = "RockerButton";
RockerButton.propTypes = {
  stateless: _DeprecationUtils.deprecatedStatelessProp
};
RockerButton.rockerTypes = rockerTypes;
var _default = RockerButton;
exports.default = _default;
module.exports = exports["default"];